export const onRequest = (type) => [type, '[REQUEST]'].join(' ');
export const onSuccess = (type) => [type, '[SUCCESS]'].join(' ');
export const onFailure = (type) => [type, '[FAILURE]'].join(' ');
export const withNamespace = (type, namespace) => [namespace, type].join(' / ');

export function htmlDecode(content) {
  const txt = document.createElement('textarea');
  txt.innerHTML = content;
  return txt.value;
}

export function extractContent(html) {
  return new DOMParser().parseFromString(html, 'text/html');
}
